var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2355 4043 c-565 -69 -1112 -332 -1716 -823 -161 -130 -582 -539 -618 -600 -44 -74 -30 -101 157 -292 673 -691 1363 -1105 2052 -1235 136 -25 524 -25 660 0 553 104 1074 373 1645 850 138 116 532 505 564 557 39 65 30 90 -87 237 -183 229 -421 464 -659 650 -469 366 -970 583 -1494 648 -111 13 -419 19 -504 8z m415 -214 c464 -42 935 -234 1380 -562 218 -160 468 -395 648 -607 40 -47 72 -90 72 -95 0 -13 -239 -249 -360 -356 -626 -554 -1218 -859 -1785 -920 -685 -73 -1522 329 -2325 1119 l-155 152 156 153 c521 511 1037 852 1539 1018 292 96 537 125 830 98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2385 3396 c-282 -65 -517 -264 -616 -521 -43 -112 -59 -194 -59 -315 0 -121 16 -203 59 -315 101 -263 356 -472 636 -524 81 -15 247 -13 325 3 221 47 412 177 539 366 96 144 141 294 141 470 0 177 -45 326 -142 471 -108 162 -258 276 -446 339 -88 30 -110 33 -237 36 -95 3 -159 -1 -200 -10z m310 -211 c216 -45 409 -223 478 -440 18 -57 22 -93 22 -190 -1 -104 -5 -130 -27 -193 -37 -104 -83 -176 -158 -252 -76 -76 -167 -132 -265 -163 -57 -18 -93 -22 -190 -22 -104 1 -130 5 -193 27 -105 38 -176 83 -257 163 -193 192 -239 484 -115 731 132 261 418 399 705 339z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.a3dce6cd.svg";
export { ForwardRef as ReactComponent };